import { z } from 'zod';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';

export const templateSignatureSchema = templateNamedWidgetSchema.extend({
  type: z.literal('signature'),
  isRequired: z.boolean(),
  ...fieldLayoutShape,
  /**
   * 簽名圖片（PNG base64 data URL），未簽名時為空字串。
   */
  value: z.string(),
});

export type TemplateSignatureV1 = z.infer<typeof templateSignatureSchema>;
